import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const animateOnTabChange = {
    $trigger: $('#solutions-tabs'),
    init: function () {
        this.$trigger.on('change.zf.tabs', function () {
            setTimeout(() => ScrollTrigger.refresh(), 300)
        })
    },
}

animateOnTabChange.init()
